import axios from "axios";
import ReactDOMServer from "react-dom/server";

const DownloadRequest = async (
  url,
  params = {},
  options = { isMultiMedia: false, showLoader: false, auth: true }
) => {
  const { showLoader = false, isMultiMedia = false, auth = true } = options;

  var oldButtonText = "";
  var targetElement = document.getElementById(showLoader);

  if (showLoader && targetElement) {
    oldButtonText = targetElement.innerHTML;
    targetElement.innerHTML = `${ReactDOMServer.renderToString(
      // <LuLoader2 />
      <div className="d-flex align-items-center">
        <div className="loader-button me-2"></div>
        <span>Please wait...</span>
      </div>
    )}`;
    targetElement.setAttribute("disabled", true);
  }

  try {
    const header = {
      "content-type": "application/json",
    };

    if (auth) {
      header.Authorization = `Token ${window.localStorage.getItem("TOKEN")}`;
    }

    const response = await axios.get(`${url}`, {
      headers: header,
      responseType: 'arraybuffer',
      crossDomain: true,
    });

    const responseData = response.data;
    if (response.status == 200) {
      return response.data

    } else {
      throw new Error('Oops! Failed to download this file!');
    }

  } catch (error) {
    switch (error.status) {
      case 401:
        window.location.href = "/sign-in";
        break;

      default:
        throw new Error(error.message);
        break;
    }
  } finally {
    if (showLoader && targetElement) {
      targetElement.innerHTML = oldButtonText;
      targetElement.removeAttribute("disabled");
    }
  }
};
export default DownloadRequest;
